export interface Input {
  level: "error" | "success" | "information" | "warning";
  onDismiss?: () => void;
  content: Marko.Body;
}

<div.notification.admonition.admonition--${input.level}.${
  input.onDismiss && `notification--dismissable`
}>
  <div.notification__icon>
    <sb-icon icon=input.level title=`Notification level ${input.level}`/>
  </div>
  <div>
    <${input.content}/>
  </div>
  <if=input.onDismiss>
    <button aria-label="Dismiss" onClick=input.onDismiss>
      <sb-icon icon="x-mark"/>
    </button>
  </if>
</div>

<style.scss>
  .notification {
    @include body-md-regular;

    align-items: start;
    background: var(--admonition-background-color);
    border: 1px solid var(--admonition-foreground-color);
    border-radius: $radius-md;
    display: grid;
    font-weight: $font-weight-medium;
    gap: $space-md;
    grid-template-columns: 1.5em 1fr;
    padding: $space-md;

    &__icon {
      color: var(--admonition-foreground-color);
    }

    &--dismissable {
      grid-template-columns: 1.5em 1fr 1.5em;
    }
  }
</style>

<admonition/>
